export const environment = {
  production: true,
  // Move to assets/environment.json.
  //apiUrl: 'http://'
};
